/**
 * usePostalCodeLookupPort — port-factory hook returning a stable
 * PostalCodeLookupPort adapter for production composition.
 *
 * The composer (`Composition`) calls this once to obtain a PostalCodeLookupPort
 * instance for PortsProvider. useState's lazy initialiser keeps the adapter
 * reference stable across re-renders (and gives a fresh adapter per React root).
 *
 * 034 US3: this now builds the REAL tRPC-backed `TrpcPostalCodeLookup` over
 * `member.profile.postalLookup` (the member's cookie session authenticates the
 * same-origin request). The retired `DemoPostalCodeLookupAdapter` static map
 * survives only as a test fixture (see `renderAppWithPorts`), never in the
 * shipped path (SC-009).
 *
 * Owned by feature 026-proto-convergence-v2; reworked by 034-member-is-reads US3.
 */

import { useState } from 'react';
import type { PostalCodeLookupPort } from '../contact-verification/PostalCodeLookupPort.js';
import { TrpcPostalCodeLookup } from '../contact-verification/TrpcPostalCodeLookup.js';
import { createWebTrpcClient } from '../trpc/client.js';

export function usePostalCodeLookupPort(): PostalCodeLookupPort {
  const [port] = useState<PostalCodeLookupPort>(
    () => new TrpcPostalCodeLookup(createWebTrpcClient()),
  );

  return port;
}
